import { AddBusiness, SettingsOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import React from "react";
import { Organization } from "model/organizationModel";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
import OrganizationSelector from "./OrganizationSelector";
import { getTranslation } from "common";
import { useTranslations } from "hooks";

interface OrganizationsHeaderProps {
  organizations: Organization[];
  selectedOrganization?: Organization | null;
  onSelectOrganization: (organization: Organization) => void;
  onCreateOrganization: () => void;
  onOpenSettings: () => void;
}

const OrganizationsHeader: React.FC<OrganizationsHeaderProps> = ({
  organizations,
  selectedOrganization,
  onSelectOrganization,
  onCreateOrganization,
  onOpenSettings,
}) => {
  const translations = useTranslations();
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "stretch", sm: "center" }}
      justifyContent="space-between"
      spacing={2}
      sx={{ px: { xs: 1, md: 2 }, pt: { xs: 1, md: 2 } }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <OrganizationSelector
          organizations={organizations}
          selectedOrganization={selectedOrganization}
          onSelect={onSelectOrganization}
        />
      </Box>
      <Stack direction="row" justifyContent={{ xs: "space-between", sm: "flex-end" }} spacing={1} sx={{ flexShrink: 0 }}>
        <FlowentiButton
          id="btn-organizations-card"
          size="small"
          variant="outlined"
          startIcon={<AddBusiness />}
          onClick={onCreateOrganization}
        >
          {getTranslation(translations, 'organizations.edit.suggestnew')}
        </FlowentiButton>
        <Box>
          <Tooltip title={getTranslation(translations, "settings.name")}>
            <span>
              <IconButton
                id={selectedOrganization?.id ? `btn-modify-org-${selectedOrganization.id}` : "btn-modify-org"}
                size="small"
                aria-label={getTranslation(translations, "settings.name")}
                disabled={!selectedOrganization?.id || !selectedOrganization.administrator}
                onClick={onOpenSettings}
              >
                <SettingsOutlined />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Stack>
    </Stack>
  )
};

export default OrganizationsHeader;
